const sideMenu = [
  {
    id: "events",
    label: "Events",
    href: "/admin/event",
    permissions: [1,3]
  },
  {
    id: "voucher",
    label: "Voucher",
    href: "/admin/voucher",
    permissions: [1,3]
  },
  {
    id: "userlist",
    label: "User Management",
    href: "/admin/users",
    permissions: [3]
  },
];

export default sideMenu;
